// extracted by mini-css-extract-plugin
export default {"faqAppHero":"faqAppHero_QtDc9","text":"text_isksg","image":"image_Mv0K9","apps":"apps_trTer"};